/** Build a URL inside the configured Vite application base path. */
export function appPath(path = '/') {
  const base = import.meta.env.BASE_URL || '/';
  const cleanPath = String(path).startsWith('/') ? String(path).slice(1) : String(path);
  return `${base}${cleanPath}`.replace(/\/\//g, '/');
}
